import script from "./AnnouncementList.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementList.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementList.vue?vue&type=style&index=0&id=266be724&lang=css"

const __exports__ = script;

export default __exports__